"use client";
export { SliderWrapper as default } from "../../../_Builtin/Slider";
